import React from "react";

// ✅ Flat structure to match your required response format
export const defaultEnergyData = [
  {
    section: "From Renewable sources",
    label: "Total electricity consumption (A)",
    key: "renewableA",
    current: "",
    previous: "",
  },
  {
    section: "From Renewable sources",
    label: "Total fuel consumption (B)",
    key: "renewableB",
    current: "",
    previous: "",
  },
  {
    section: "From Renewable sources",
    label: "Energy consumption through other sources (C)",
    key: "renewableC",
    current: "",
    previous: "",
  },
  {
    section: "From Renewable sources",
    label: "Total energy consumed from renewable sources (A+B+C)",
    key: "renewableTotal",
    current: "",
    previous: "",
  },
  {
    section: "From Non-renewable sources",
    label: "Total electricity consumption (D)",
    key: "nonRenewableD",
    current: "",
    previous: "",
  },
  {
    section: "From Non-renewable sources",
    label: "Total fuel consumption (E)",
    key: "nonRenewableE",
    current: "",
    previous: "",
  },
  {
    section: "From Non-renewable sources",
    label: "Energy consumption through other sources (F)",
    key: "nonRenewableF",
    current: "",
    previous: "",
  },
  {
    section: "From Non-renewable sources",
    label: "Total energy consumed from non-renewable sources (D+E+F)",
    key: "nonRenewableTotal",
    current: "",
    previous: "",
  },
  {
    section: "Total Energy consumed (A+B+C+D+E+F)",
    label:
      "Energy intensity per rupee of turnover (Total energy consumed/ Revenue from operations)",
    key: "intensityTurnover",
    current: "",
    previous: "",
  },
  {
    section: "Total Energy consumed (A+B+C+D+E+F)",
    label:
      "Energy intensity per rupee of turnover adjusted for Purchasing Power Parity (PPP)",
    key: "intensityPPP",
    current: "",
    previous: "",
  },
  {
    section: "Total Energy consumed (A+B+C+D+E+F)",
    label: "Energy intensity in terms of physical output",
    key: "intensityOutput",
    current: "",
    previous: "",
  },
  {
    section: "Total Energy consumed (A+B+C+D+E+F)",
    label:
      "Energy intensity (optional) – the relevant metric may be selected by the entity",
    key: "intensityOptional",
    current: "",
    previous: "",
  },
];

const EnergyConsumptionTable = ({ energyData = [], setEnergyData }) => {
  const flatData =
    Array.isArray(energyData) && energyData.length > 0
      ? energyData
      : defaultEnergyData;

  const handleChange = (index, field, value) => {
    const updated = [...flatData];
    updated[index][field] = value;
    setEnergyData(updated);
  };

  const renderRow = (row, index) => (
    <tr key={`${row.section}-${row.key}`}>
      <td style={leftCellStyle}>{row.label}</td>
      <td style={cellStyle}>
        <input
          type="text"
          placeholder="Current FY"
          value={row.current || ""}
          onChange={(e) => handleChange(index, "current", e.target.value)}
          style={inputStyle}
        />
      </td>
      <td style={cellStyle}>
        <input
          type="text"
          placeholder="Previous FY"
          value={row.previous || ""}
          onChange={(e) => handleChange(index, "previous", e.target.value)}
          style={inputStyle}
        />
      </td>
    </tr>
  );

  const groupedData = flatData.reduce((acc, row, index) => {
    if (!acc[row.section]) acc[row.section] = [];
    acc[row.section].push({ ...row, index });
    return acc;
  }, {});

  return (
    <div
      style={{
        marginTop: 20,
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th rowSpan="2" style={headerStyle}>
              Parameter
            </th>
            <th style={headerStyle}>
              FY ____ <br /> Current Financial Year
            </th>
            <th style={headerStyle}>
              FY ____ <br /> Previous Financial Year
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(groupedData).map(([section, rows]) => (
            <React.Fragment key={section}>
              <tr>
                <td colSpan="3" style={sectionHeaderStyle}>
                  {section}
                </td>
              </tr>
              {rows.map((row) => renderRow(row, row.index))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid black",
  textAlign: "center",
  width: "20%",
};

const sectionHeaderStyle = {
  padding: "10px",
  backgroundColor: "#D3C9CE",
  fontWeight: "bold",
  border: "1px solid black",
  textAlign: "center",
};

const leftCellStyle = {
  padding: "10px",
  border: "1px solid black",
  backgroundColor: "#F0E9EC",
  fontWeight: "bold",
  textAlign: "left",
  width: "30%", // Reduced width for parameter column
};

const cellStyle = {
  padding: "8px",
  border: "1px solid black",
  textAlign: "center",
};

const inputStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
};

export default EnergyConsumptionTable;
